import type { TierMemberCounts } from '@/types/pool/poolTypes'
import { DECIMAL_PRECISION, TIER_DEPOSITS } from '#shared/constants/vaultRules'

export type { PoolMembershipStats, TierMemberCounts } from '@/types/pool/poolTypes'

export function sumExpectedMemberDeposits(membersByTier: TierMemberCounts): number {
  const trialDeposits = (membersByTier.trial ?? 0) * TIER_DEPOSITS.trial
  const bronzeDeposits = (membersByTier.bronze ?? 0) * TIER_DEPOSITS.bronze
  const silverDeposits = (membersByTier.silver ?? 0) * TIER_DEPOSITS.silver
  const goldDeposits = (membersByTier.gold ?? 0) * TIER_DEPOSITS.gold

  return trialDeposits + bronzeDeposits + silverDeposits + goldDeposits
}

export function sumExpectedMemberDepositsWei(membersByTier: TierMemberCounts): bigint {
  const deposits = sumExpectedMemberDeposits(membersByTier)
  return BigInt(deposits * DECIMAL_PRECISION.CONVERSION_FACTOR)
}

export function deriveSponsorDeposits(totalAssets: bigint, memberDeposits: bigint): bigint {
  if (totalAssets <= memberDeposits)
    return 0n
  return totalAssets - memberDeposits
}

export function usdToWei(amount: number): bigint {
  return BigInt(amount * DECIMAL_PRECISION.CONVERSION_FACTOR)
}
